export type FpsHandler = {
  update(): void;
  getFps(): string;
};

export function fpsCounter() {
  let fpsString: string = $state('0');
  let frameCount: number = $state(0);
  let lastTime: number = Date.now();

  return {
    update() {
      const now = Date.now();

      frameCount++;
      const elapsed: number = (now - lastTime) / 1000;
      if (elapsed >= 1) {
        fpsString = (frameCount / elapsed).toFixed(2);
        frameCount = 0;
        lastTime = now;
      }
    },
    getFps(): string {
      return fpsString;
    },
  };
}
